export class Hour {
    #hour
    #minutes

    constructor(hour, minutes) {
        this.#hour = hour
        this.#minutes = minutes
    }

    get getHour() {
        return this.#hour
    }

    get getMinutes() {
        return this.#minutes
    }

    secondsPastFromMidnight() {
        return this.#hour*60 + this.#minutes
    }

    asNextDay() {
        return 24*60 + this.secondsPastFromMidnight()
    }
}

class HoursRange {
    #start
    #end

    constructor(start, end) {
        if(start.getHour >= 0 && start.getHour < 24 && start.getMinutes >= 0 && start.getMinutes < 60 
            && end.getHour >= 0 && end.getHour < 24 && end.getMinutes >= 0 && end.getMinutes < 60) {
            this.#start = start
            this.#end = end
        } else {
            this.#start = null
            this.#end = null
        }
    }

    get getStart() {
        return this.start
    }

    get getEnd() {
        return this.end
    }

    containsHour(hour) {
        if (!hour) {
            return false
        } else {
            if(!!this.#start && !!this.#end) {
                if(this.#start.secondsPastFromMidnight() < this.#end.secondsPastFromMidnight()) {
                    return hour.secondsPastFromMidnight() >= this.#start.secondsPastFromMidnight() && hour.secondsPastFromMidnight() <= this.#end.secondsPastFromMidnight()
                } else {
                    let hoursAsMinutes = (hour.secondsPastFromMidnight() < 24*60) ? hour.secondsPastFromMidnight() : hour.asNextDay()
    
                    return hoursAsMinutes >= this.#start.secondsPastFromMidnight() && hoursAsMinutes <= this.#end.asNextDay() 
                }
            } else {
                return false
            }
        }
    }
    
}

class OpenHours {
    #hourRanges = []
    #atLeastOneOpenHour

    get hasOpenHours() {
        return this.#atLeastOneOpenHour
    }

    set setOpenHours(anyOpenHour) {
        this.#atLeastOneOpenHour = anyOpenHour
    }

    addRange(range) {
        this.#hourRanges.push(range)
    }

    isOpen(atHour) {
        return this.#hourRanges.reduce((isIncluded, nextHour) => {
            return isIncluded || nextHour.containsHour(atHour)
        }, false)
    }
}

export const extractOpenHoursFromCategory = (category, restaurant) => {
    let openHours = category["openHours"] ?? restaurant["openHours"] ?? null

    if (openHours != null) {
        const dayNumber = new Date().getDay();
        const today =  ['sun','mon','tue','wed','thu','fri','sat'][ dayNumber ];
    
        if (today != null && openHours[today] > 0) {
            let allOpenHourRanges = openHours[today].split(',')

            let allHoursAsString = allOpenHourRanges.flatMap(range => range.split('-'))

            let allHours = allHoursAsString.map(hourMinutePair => {
                let [hour, minute] = hourMinutePair.split(':')
                return new Hour(parseInt(hour), parseInt(minute))
            })

            let ranges = new OpenHours()
            for(var i=0; i < allHours.length; i+=2) {
                ranges.addRange(new HoursRange(allHours[i], allHours[i+1]))
            }

            ranges.setOpenHours = true

            return ranges
        } else {
            let oh = new OpenHours()
            oh.setOpenHours = false
            return oh
        }
    } else {
        let oh = new OpenHours()
        oh.setOpenHours = false
        return oh
    }
}